import { t } from '@lingui/macro';

// Status vocabulary shared by the cascade summary and the Shared Settings panel.
// Colours follow the integration's locations list: success for live, the neutral
// licoriceMousse for anything deliberately not live, warning for "needs a human",
// danger for a real failure.
const NEUTRAL = 'licoriceMousse';

// A created peer is only enabled when every attribute its integration requires
// already has a value; otherwise it arrives disabled and names what is missing.
export const cascadeStatusTag = (result) => {
  switch (result.status) {
    case 'created':
      return result.enabled
        ? { statusText: t`Enabled`, statusColor: 'success' }
        : { statusText: t`Disabled`, statusColor: 'warning' };
    case 'enabled':
      return { statusText: t`Enabled`, statusColor: 'success' };
    case 'disabled':
      return { statusText: t`Disabled`, statusColor: NEUTRAL };
    case 'removed':
      return { statusText: t`Removed`, statusColor: NEUTRAL };
    case 'blocked':
      return { statusText: t`Needs data`, statusColor: 'warning' };
    case 'failed':
      return { statusText: t`Failed`, statusColor: 'danger' };
    case 'excluded':
      return { statusText: t`Excluded from sync`, statusColor: NEUTRAL };
    case 'not_present':
      return { statusText: t`Not configured`, statusColor: NEUTRAL };
    case 'already_present':
      return { statusText: t`Already there`, statusColor: NEUTRAL };
    case 'already_enabled':
      return { statusText: t`Already enabled`, statusColor: NEUTRAL };
    case 'already_disabled':
      return { statusText: t`Already disabled`, statusColor: NEUTRAL };
    default:
      return { statusText: result.status, statusColor: NEUTRAL };
  }
};

// Where a location currently stands in one integration of its group. `undefined`
// means the location is not configured there at all.
export const locationStateTag = (configuration) => {
  if (!configuration) {
    return { statusText: t`Not configured`, statusColor: NEUTRAL };
  }
  if (configuration.ignore_shared_setting_actions) {
    return { statusText: t`Excluded from sync`, statusColor: 'warning' };
  }
  return configuration.enabled
    ? { statusText: t`Enabled`, statusColor: 'success' }
    : { statusText: t`Disabled`, statusColor: NEUTRAL };
};
